import React from "react";
import { useLocation } from "react-router-dom";
import NotificationComposer from "./NotificationComposer";
import NotificationDetails from "./NotificationDetails";
import NotificationsDashboard from "./NotificationsDashboard";
import styles from "./notifications.module.scss";

const NotificationsManager: React.FC = () => {
  const location = useLocation();
  const basePath = "/app/settings/notifications";

  let content: React.ReactNode;

  if (location.pathname === `${basePath}/new`) {
    content = <NotificationComposer />;
  } else if (location.pathname.startsWith(`${basePath}/`)) {
    const id = decodeURIComponent(location.pathname.slice(`${basePath}/`.length));
    content = <NotificationDetails id={id} />;
  } else {
    content = <NotificationsDashboard />;
  }

  return <div className={styles["notification-workspace"]}>{content}</div>;
};

export default NotificationsManager;
